import React from "react";
import PropTypes from "prop-types";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import { Consumer as CurrentCardsVisibleConsumer } from "../../currentCardsVisibleContext";

var CarouselItem = function CarouselItem(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(CarouselItem.displayName);
  var cardsVisibleOne = 1;
  var cardsVisibleTwo = 2;
  var cardsVisibleThree = 3;
  return /*#__PURE__*/React.createElement(CurrentCardsVisibleConsumer, null, function (context) {
    return /*#__PURE__*/React.createElement("div", {
      className: getClassName({
        states: classNames({
          cardsVisibleOne: context === cardsVisibleOne,
          cardsVisibleTwo: context === cardsVisibleTwo,
          cardsVisibleThree: context === cardsVisibleThree
        })
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: getClassName({
        descendantName: "inner"
      })
    }, children));
  });
};

CarouselItem.displayName = "CarouselItem";
CarouselItem.propTypes = {
  /**
   * Child card nodes
   */
  children: PropTypes.node,

  /**
   * Intro nodes
   */
  cardsVisible: PropTypes.number
};
export default CarouselItem;